(function() {
    'use strict';
    
    const overlay = document.getElementById('nosto-autocomplete-overlay');
    if (!overlay) return;

    function isDesktop() {
        return window.innerWidth >= 1024;
    }

    function getDesktopWrapper() {
        const form = document.querySelector('form[id^="form-search-inline"]');
        if (!form) return null;
        const wrappers = form.querySelectorAll('.nosto-autocomplete-wrapper > div[tabindex]');
        // Target specifically the autocomplete wrapper (ignore history wrapper)
        return wrappers.length > 0 ? wrappers[wrappers.length - 1] : null;
    }

    function syncOverlay() {
        const wrapper = getDesktopWrapper();
        const isVisible = wrapper && wrapper.style.display !== 'none';
        overlay.style.display = (isVisible && isDesktop()) ? 'block' : 'none';
    }

    function hideOverlay() {
        overlay.style.display = 'none';
        const input = document.getElementById('search-inline-input');
        if (input) input.blur();
    }

    window.addEventListener('nosto:autocomplete:show', syncOverlay);
    document.addEventListener('focusin', syncOverlay);
    document.addEventListener('focusout', syncOverlay);
    document.addEventListener('click', function() {
        // Delay needed: click fires before Nosto updates DOM - otherwise overlay doesnt hide, this is the best we could come up with
        setTimeout(syncOverlay);
    });
    window.addEventListener('resize', syncOverlay);
    
    // Hide overlay when Enter is pressed in search input
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && e.target.id === 'search-inline-input') {
            setTimeout(hideOverlay);
        }
    });

    overlay.addEventListener('click', hideOverlay);
})();
